<div class="calendar-container" [class.drawer-open]="selectedDate"
 style="background-color: var(--surface-overlay);
  border-radius: 36px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
 ">
 <div class="calendar-header">
    <div *ngIf="value === 'month'" class="calendar-navigation">
      <p-button 
        icon="pi pi-chevron-left"
        [text]="true"
        [rounded]="true"
        size="small"
        (onClick)="previousMonth()" 
        ariaLabel="Previous month">
      </p-button>
      
      <div class="month-year-display">
        <h2>{{ getCurrentMonthYear() }}</h2>
      </div>
      
      <p-button 
        icon="pi pi-chevron-right"
        [text]="true"
        [rounded]="true"
        size="small"
        (onClick)="nextMonth()" 
        ariaLabel="Next month">
      </p-button>
    </div>

    <div *ngIf="value === 'week'" class="calendar-navigation">
      <p-button 
        icon="pi pi-chevron-left"
        [text]="true"
        [rounded]="true"
        size="small"
        (onClick)="previousWeek()" 
        ariaLabel="Previous week">
      </p-button>
      
      <div class="week-range-display">
        <h2>{{ getWeekRange() }}</h2>
      </div>
      
      <p-button 
        icon="pi pi-chevron-right"
        [text]="true"
        [rounded]="true"
        size="small"
        (onClick)="nextWeek()" 
        ariaLabel="Next week">
      </p-button>
    </div>

    <div class="modern-button-container">
      <p-selectButton 
        [options]="stateOptions" 
        [(ngModel)]="value" 
        optionLabel="label" 
        optionValue="value"
        styleClass="modern-select-button"
        unselectable="on">
      </p-selectButton>
    </div>
  </div>


 <div *ngIf="value === 'month'" class="calendar-container">
  <app-month-calendar (dateSelected)="onDateSelected($event)" [displayedDate]="currentDate"
  [customers]="customers" [orders]="orders"></app-month-calendar>
 </div>
 <div *ngIf="value === 'week'" class="calendar-container">
  <app-week-calendar [customers]="customers" [orders]="orders"></app-week-calendar>
 </div>

  <div class="drawer-backdrop" 
       *ngIf="selectedDate"
       (click)="closeDrawer()"
       [@fadeInOut]></div>

  <div class="order-drawer" 
       *ngIf="selectedDate"
       [@slideRightLeft]>
    

    <div class="drawer-header">
      <div class="drawer-title">
        <h3>{{ selectedDate | date:'fullDate' }}</h3>
        <p class="order-count">
          <i class="pi pi-calendar"></i>
          {{ getOrderCount(selectedDate) }} orders scheduled
        </p>
      </div>
    </div>


    <div class="drawer-content">
      <div class="orders-list" *ngIf="getOrdersForDate(selectedDate).length > 0; else noOrders">
        <div class="order-card" 
             *ngFor="let order of getOrdersForDate(selectedDate)"
             [class.status-unassigned]="order.load_status.toLowerCase() === 'unassigned'"
             [class.status-scheduled]="order.load_status.toLowerCase() === 'scheduled'"
             [class.status-loaded]="order.load_status.toLowerCase() === 'loaded'"
             [class.status-delivered]="order.load_status.toLowerCase() === 'delivered'">
          
             <div class="flex align-items-center justify-content-center pb-2">
                <span class="flex-1 text-center" style=" font-weight: 600; color: var(--blue-600);">{{ getCustomerName(order.supplier_id) }}</span>
                <i class="pi pi-arrow-right flex-shrink-0"></i>
                <span class="flex-1 text-center" style=" font-weight: 600; color: var(--green-600);">{{ getCustomerName(order.receiver_id) }}</span>
              </div>
          
          <div class="order-card-body">
            <div class="order-detail-row">
              <span class="label">Load Type:</span>
              <span class="value">{{ order.load_type }}</span>
            </div>
            <div class="order-detail-row">
              <span class="label">Status:</span>
              <span class="value status-text" [class]="'status-' + order.load_status.toLowerCase()">
                {{ order.load_status }}
              </span>
            </div>
            <div class="order-detail-row" *ngIf="order.pickup_date">
              <span class="label">Pickup Date:</span>
              <span class="value">{{ toCentralTime(order.pickup_date)}}</span>
            </div>
            <div class="order-detail-row" *ngIf="order.delivery_date">
              <span class="label">Delivery Date:</span>
              <span class="value">{{ toCentralTime(order.delivery_date)}}</span>
            </div>
          </div>
          
          <div class="flex align-items-center justify-content-between gap-1">
            <p-button class="flex-1" type="button" icon="pi pi-eye" label="View Orders Page" (onClick)="viewOrdersPage(order.order_id)"
            [style]="{'width': '100%', 'font-size': '12px'}" [raised]="true">
            </p-button>
            <p-button class="flex-1" type="button" label="Edit Order" icon="pi pi-pencil" (onClick)="editOrder(order)" [raised]="true"
             [style]="{'width': '100%', 'font-size': '12px'}">
            </p-button>
          </div>
        </div>
      </div>
      
      <ng-template #noOrders>
        <div class="no-orders">
          <i class="pi pi-calendar"></i>
          <h4>No orders scheduled</h4>
          <p>There are no orders scheduled for this date.</p>
        </div>
      </ng-template>
    </div>
  </div>
</div>


<app-edit-order-dialog 
  [allOrders]="orders"
  [customers]="customers"
  #editOrderDialog>
</app-edit-order-dialog>

